import type {AppBarProps} from '@mui/material/AppBar';
import MuiAppBar from '@mui/material/AppBar';
import {styled} from "@mui/material/styles";
import {DRAWER_COLLAPSED_WIDTH_LG, DRAWER_COLLAPSED_WIDTH_SM, DRAWER_WIDTH} from "./DrawerConstants.ts";

// Taken from https://github.com/mui/material-ui/blob/v7.3.6/docs/data/material/components/drawers/MiniDrawer.tsx

interface Props extends AppBarProps {
    open?: boolean;
}

export const DrawerTopBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<Props>(({theme}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({open}) => open,
            style: {
                marginLeft: DRAWER_WIDTH,
                width: `calc(100% - ${DRAWER_WIDTH}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
        {
            props: ({open}) => !open,
            style: {
                marginLeft: DRAWER_COLLAPSED_WIDTH_SM,
                width: `calc(100% - ${DRAWER_COLLAPSED_WIDTH_SM}px)`,

                // Ensure compatibility with theme.mixins.toolbar
                '@media (min-width: 600px)': {
                    marginLeft: DRAWER_COLLAPSED_WIDTH_LG,
                    width: `calc(100% - ${DRAWER_COLLAPSED_WIDTH_LG}px)`,
                },
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));
